import { motion } from 'framer-motion';

const BlurFade = ({ children, delay = 0, className = '' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, filter: 'blur(6px)', transform: 'translateY(8px)' }}
      whileInView={{ opacity: 1, filter: 'blur(0px)', transform: 'translateY(0px)' }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ delay, duration: 0.4, ease: 'easeOut' }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default BlurFade;
